package co.maytes.standupbot.dashboard.pages.app.standups.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.components.feedback.Modal
import co.maytes.standupbot.dashboard.components.widgets.Button
import co.maytes.standupbot.dashboard.components.widgets.ButtonVariant
import co.maytes.standupbot.dashboard.components.widgets.DatePicker
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.todayIn

@Composable
internal fun RunForDateModal(
    teamTimezoneId: String,
    onConfirm: (LocalDate) -> Unit,
    onDismiss: () -> Unit,
) {
    val tz = remember(teamTimezoneId) {
        runCatching { TimeZone.of(teamTimezoneId) }.getOrDefault(TimeZone.UTC)
    }
    val today = remember(tz) { Clock.System.todayIn(tz) }
    var picked by remember(today) { mutableStateOf(today.toString()) }

    Modal(
        onDismiss = onDismiss,
        title = "Run for a specific date",
        dismissOnScrim = false,
        widthPx = 420,
        footer = {
            Button(
                label = "Cancel",
                variant = ButtonVariant.Ghost,
                onClick = onDismiss,
            )
            Button(
                label = "Run",
                variant = ButtonVariant.Primary,
                enabled = picked.isNotBlank(),
                onClick = {
                    val parsed = runCatching { LocalDate.parse(picked) }.getOrNull()
                    if (parsed != null) onConfirm(parsed)
                },
            )
        },
    ) {
        SpanText(
            text = "Pulls Linear activity around the chosen day (in ${tz.id}) and generates a standup as if the standup's schedule had fired then. Useful for back-filling.",
            modifier = Modifier
                .fontSize(Typography.bodySmall.size)
                .color(Palette.textSecondary)
                .margin(bottom = Spacing.lg),
        )

        DatePicker(
            value = picked,
            onChange = { picked = it },
            label = "Target date",
            max = today.toString(),
            modifier = Modifier.fillMaxWidth(),
        )
    }
}
